<template>
  <div class="titleTab">
    <!-- 推荐tab栏 -->
    <van-tabs v-model="active" :before-change="beforeChange" type="card">
      <!-- <van-tab title="推荐">
        <knowledge
          :babyCurrentNum="babyCurrentNum"
          :babyDays="babyDays"
          :loginFlag="loginFlag"
          :editFlag="editFlag"
          :tagId="parentTagId"
          @getShow="getShow"
        />
      </van-tab> -->
      <van-tab title="奶娃宝典"></van-tab>
      <van-tab title="星专家"></van-tab>
      <van-tab title="星生活"></van-tab>
    </van-tabs>
  </div>
</template>
<script>
import knowledge from "@/components/home/knowledge.vue"; //能不能吃互动
import { BuiedPointClick_Fn } from "../../assets/js/BuriedPointEvent";
import { changeIncludes } from "../../store";
export default {
  props: ["loginFlag", "editFlag", "babyDays", "tagId", "babyCurrentNum"],
  data() {
    return {
      active: 0, //tab默认下标
      parentTagId: "", //状态
    };
  },
  watch: {
    tagId(newVal) {
      //状态
      // console.log("123", newVal)
      this.parentTagId = newVal; //状态
    },
  },
  mounted() {
    this.parentTagId = this.tagId; //状态
    console.log("09090909", this.parentTagId)
  },
  methods: {
    getShow(e) {
      this.$emit("getOpen", e);
    },
    //点击切换该页面
    beforeChange(index) {
      switch (index) {
        case 0:
          // 埋点
          BuiedPointClick_Fn("xmhh5_home_nrdhl_click", {
            xmhh5_home_nrdhl_name: "奶娃宝典",
          });
          setTimeout(() => {
            this.$router.push({ path: "/babyWikipedia" ,query:{from:"home"}}); //奶娃宝典页
          }, 300);
          break;
        case 1:
          // 埋点
          BuiedPointClick_Fn("xmhh5_home_nrdhl_click", {
            xmhh5_home_nrdhl_name: "星专家",
          });
          setTimeout(() => {
            this.$router.push({ path: "/expertsView" ,query:{from:'home'}}); //星专家页
          }, 300);
          break;
        case 2:
          // 埋点
          BuiedPointClick_Fn("xmhh5_home_nrdhl_click", {
            xmhh5_home_nrdhl_name: "星生活",
          });
          setTimeout(() => {
            location.href = "./lineDoctor?toUrlSource=8";
          }, 300);
          break; //星生活页
      }
    },
  },
  components: {
    knowledge,
  },
};
</script>

<style lang="less" scoped>
.titleTab {
  width: 375px;
  // 选择状态
  /deep/ .van-tabs {
    justify-content: space-between;
    .van-tab {
      padding: 0 14px;
      flex: none;
      height: 28px;
      line-height: 29px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #eee;
      margin-right: 8px;
      color: #666666;
      border-radius: 14px;
    }
    .van-tabs__nav--card {
      border: none;
      margin-left: 18px;
      height: auto;
    }
    .van-tabs__nav {
      background: transparent;
    }
    // .van-tab--active {
    //  background: #FEDBF0;
    //  font-size: 14px;
    //  font-family: PingFangSC-Regular, PingFang SC;
    //  font-weight: 600;
    //  color: #FF67C1;
    //  border-radius: 14px;
    //  border: none;
    // }
    .van-tabs__wrap {
      padding-top: 21px;
      height: auto;
      .van-tabs__nav--line {
        padding-bottom: 0px;
      }
    }
  }
}
</style>